module.exports = __webpack_public_path__ + "c6a3da4abc7e05a0ec70acce0ef80e5d.mtl";